import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  Typography,
} from '@mui/material';
import SubscriptionPlanChargeDateMessage from '../SubscriptionPlanChargeDateMessage';
import { useTranslation } from 'react-i18next';
import { formatPrice } from 'helpers/formPrice';

const AcceptRequirements = ({
  handleAcceptAgreeToReceiveOrderCommunication,
  acceptAgreeToReceiveOrderCommunication,
  acceptAgreeToReceiveOrderCommunicationError,
  selectedPlan,
  handleAcceptAgreeToPayRecurringCharges,
  agreeToPayRecurringCharges,
  agreeToPayRecurringChargesError,
  selectedPlanData,
  selectedPlanPrice,
  checkNewPlans,
  isSpecialLocation = false,
  // Hardware props
  hardwareCosts = {
    hasOneTime: false,
    hasMonthly: false,
    oneTimeCost: 0,
    monthlyCost: 0,
  },
  agreeToPayHardwarePurchase = false,
  agreeToPayHardwarePurchaseError = false,
  handleAcceptAgreeToPayHardwarePurchase = () => {},
  agreeToPayHardwareMonthly = false,
  agreeToPayHardwareMonthlyError = false,
  handleAcceptAgreeToPayHardwareMonthly = () => {},
  getFormattedDate = () =>
    new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }),
}) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      {selectedPlan && selectedPlan !== 'null' && checkNewPlans ? (
        <Grid item xs={12}>
          <FormControl
            name="accept"
            component="fieldset"
            error={!!agreeToPayRecurringChargesError}
            variant="standard"
          >
            <FormGroup style={{ height: '10px', display: 'flow' }}>
              <FormControlLabel
                sx={{ marginRight: 0 }}
                control={
                  <Checkbox
                    onChange={handleAcceptAgreeToPayRecurringCharges}
                    checked={agreeToPayRecurringCharges}
                    error={true}
                    name="accept"
                  />
                }
                label={
                  <SubscriptionPlanChargeDateMessage
                    selectedPlanData={selectedPlanData}
                    selectedPlanPrice={selectedPlanPrice}
                    selectedPlan={selectedPlan}
                    isBrand={isSpecialLocation}
                  />
                }
              />
              {agreeToPayRecurringChargesError && (
                <Box>
                  <FormHelperText sx={{ marginTop: '-18px' }}>
                    {t('help.field_is_required')}
                  </FormHelperText>
                </Box>
              )}
            </FormGroup>
          </FormControl>
        </Grid>
      ) : (
        ''
      )}

      {/* Hardware One-Time Purchase Agreement */}
      {hardwareCosts.hasOneTime && (
        <Grid item xs={12}>
          <FormControl
            name="hardwarePurchase"
            component="fieldset"
            error={!!agreeToPayHardwarePurchaseError}
            variant="standard"
          >
            <FormGroup style={{ height: '10px', display: 'flow' }}>
              <FormControlLabel
                sx={{ marginRight: 0 }}
                control={
                  <Checkbox
                    onChange={handleAcceptAgreeToPayHardwarePurchase}
                    checked={agreeToPayHardwarePurchase}
                    error={true}
                    name="hardwarePurchase"
                  />
                }
                label={
                  <Typography sx={{ fontSize: '1rem' }}>
                    I agree to be charged{' '}
                    <strong>{formatPrice(hardwareCosts.oneTimeCost)}</strong>{' '}
                    hardware purchase fee today.
                  </Typography>
                }
              />
              {agreeToPayHardwarePurchaseError && (
                <Box>
                  <FormHelperText sx={{ marginTop: '-18px' }}>
                    {t('help.field_is_required')}
                  </FormHelperText>
                </Box>
              )}
            </FormGroup>
          </FormControl>
        </Grid>
      )}

      {/* Hardware Monthly Agreement */}
      {hardwareCosts.hasMonthly && (
        <Grid item xs={12}>
          <FormControl
            name="hardwareMonthly"
            component="fieldset"
            error={!!agreeToPayHardwareMonthlyError}
            variant="standard"
          >
            <FormGroup style={{ height: '10px', display: 'flow' }}>
              <FormControlLabel
                sx={{ marginRight: 0 }}
                control={
                  <Checkbox
                    onChange={handleAcceptAgreeToPayHardwareMonthly}
                    checked={agreeToPayHardwareMonthly}
                    error={true}
                    name="hardwareMonthly"
                  />
                }
                label={
                  <Typography sx={{ fontSize: '1rem' }}>
                    I agree to be charged{' '}
                    <strong>{formatPrice(hardwareCosts.monthlyCost)}</strong>{' '}
                    monthly for hardware lease, starting on{' '}
                    <strong>{getFormattedDate()}</strong>.
                  </Typography>
                }
              />
              {agreeToPayHardwareMonthlyError && (
                <Box>
                  <FormHelperText sx={{ marginTop: '-18px' }}>
                    {t('help.field_is_required')}
                  </FormHelperText>
                </Box>
              )}
            </FormGroup>
          </FormControl>
        </Grid>
      )}

      <Grid item xs={12}>
        <FormControl
          name="accept"
          component="fieldset"
          error={!!acceptAgreeToReceiveOrderCommunicationError}
          variant="standard"
        >
          <FormGroup style={{ height: '50px', display: 'flow' }}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handleAcceptAgreeToReceiveOrderCommunication}
                  checked={acceptAgreeToReceiveOrderCommunication}
                  error={true}
                  name="accept"
                />
              }
              label={t('settings.i_agree_grid')}
            />
            {acceptAgreeToReceiveOrderCommunicationError && (
              <FormHelperText sx={{ marginTop: '-15px' }}>
                {t('help.field_is_required')}
              </FormHelperText>
            )}
          </FormGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default AcceptRequirements;
